// extracted by mini-css-extract-plugin
module.exports = {"searchbar":"SearchInput_searchbar__37nDI","criteriaList":"SearchInput_criteriaList__3Uz6k"};